import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowLeft, BookOpen } from 'lucide-react';

export default function JackalStreetGiraffe() {
  const navigate = useNavigate();

  const jackalStatements = [
    { id: 1, statement: 'Mom always favors you.' },
    { id: 2, statement: 'Your life is such a mess.' },
    { id: 3, statement: 'You are so self centered.' },
    { id: 4, statement: 'I can\'t count on you for anything.' },
    { id: 5, statement: 'Stop bragging so much.' },
    { id: 6, statement: 'Why do you always talk to your friends about our relationship?' },
    { id: 7, statement: 'Do you care about anything besides money?' },
    { id: 8, statement: 'You\'re going on vacation again without me?' },
    { id: 9, statement: 'You\'re such a slob; you always make a mess.' },
    { id: 10, statement: 'Stop whining; grow up.' },
    { id: 11, statement: 'Can\'t you just listen to me for once?' },
    { id: 12, statement: 'You don\'t understand anything about me, do you.' },
    { id: 13, statement: 'You\'re always bossing me around.' },
    { id: 14, statement: 'You always dominate our conversations.' },
    { id: 15, statement: 'Why do I always have to do everything around here?' },
    { id: 16, statement: 'You always make my job so hard.' },
    { id: 17, statement: 'You don\'t understand anything about me, do you.' },
    { id: 18, statement: 'Why do you text me so much?' },
    { id: 19, statement: 'All you ever do is complain.' },
    { id: 20, statement: 'Talking to you is like talking to a wall.' },
    { id: 21, statement: 'If everybody did as little as you, this company would go out of business.' },
    { id: 22, statement: 'With how little you try, you expect to pass this class?' },
    { id: 23, statement: 'How come I only hear from you when you need something?' },
    { id: 24, statement: 'Stop hovering! Give me some space.' }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div className="border-b border-slate-700/50 bg-slate-900/90 backdrop-blur-sm sticky top-0 z-50">
        <div className="container mx-auto px-6 py-5">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Button onClick={() => navigate('/belonging-ebook')} variant="outline" size="sm" className="border-slate-600 hover:border-slate-500 text-white hover:bg-slate-800">
                <ArrowLeft className="h-4 w-4 mr-2" />Back to Guide
              </Button>
              <div>
                <h1 className="text-2xl font-bold text-white">Jackal Statements for Street Giraffe Practice</h1>
              </div>
            </div>
            <div className="flex items-center gap-2 text-slate-400 text-sm"><BookOpen className="h-4 w-4" /><span>Page 88</span></div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-6 py-8">
        <div className="max-w-5xl mx-auto">
          <div className="bg-green-900/20 border border-green-700/30 rounded-lg p-6 mb-8">
            <h2 className="text-xl font-bold text-white mb-4">What is Street Giraffe?</h2>
            <p className="text-green-100 leading-relaxed mb-4">
              Street giraffe is the practice of sharing honestly what's going on for us in a way that sounds natural to the listener.
            </p>
            <div className="bg-green-900/30 rounded p-4">
              <p className="text-green-200 font-semibold mb-3">Two Easy Tips:</p>
              <p className="text-green-100 mb-2">1. Do not say the words "feelings" or "needs"</p>
              <p className="text-green-100">2. Put the feelings and needs in separate sentences</p>
            </div>
          </div>
          <div className="bg-amber-900/20 border border-amber-700/30 rounded-lg p-6 mb-8">
            <p className="text-amber-200 font-semibold mb-2">Example #1: "Mom always favors you."</p>
            <p className="text-green-100 text-sm mb-2"><span className="font-semibold">Street Giraffe Honesty:</span> Ouch! That is so not how I see it. (Wait for response.) I would love for you to get how this is for me.</p>
            <p className="text-blue-100 text-sm"><span className="font-semibold">Street Giraffe Empathy:</span> Sounds like your relationship is pretty tough these days. (Wait for response.) You really want to be treated fairly, don't you.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {jackalStatements.map((item) => (
              <div key={item.id} className="bg-slate-800/40 border border-slate-700/50 rounded-lg p-4 hover:bg-slate-800/60 transition-colors">
                <div className="flex items-start gap-3">
                  <span className="text-slate-500 font-mono text-sm mt-1">{item.id}</span>
                  <p className="text-slate-100">"{item.statement}"</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
